
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.944 13.02v5.122a.844.844 0 01-.833.858h-4.028a.424.424 0 01-.417-.429v-4.003a.424.424 0 00-.417-.429h-2.5a.424.424 0 00-.417.429v4.003a.424.424 0 01-.417.429H4.887a.844.844 0 01-.833-.858V13.02c0-.128.055-.25.153-.332l6.528-5.533a.414.414 0 01.531 0l6.529 5.533c.094.082.15.204.15.332zm2.903-2.176L17.944 8.38v-4.95a.424.424 0 00-.417-.43h-1.944a.424.424 0 00-.417.43v2.595L12.058 3.39a1.629 1.629 0 00-2.118 0l-8.79 7.453a.439.439 0 00-.055.604l.886 1.108a.41.41 0 00.587.057l8.167-6.923a.414.414 0 01.531 0l8.168 6.923a.41.41 0 00.587-.057l.885-1.108a.439.439 0 00-.059-.604z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_inicio.svg